import NodeDryAirCooler from './node-dry-air-cooler';

export default NodeDryAirCooler;
